'use client'

import { getFullLocalizedUri, toLangCode } from '@/components/i18n/lang-context'
import { redirect, usePathname } from 'next/navigation'
import { useEffect } from 'react'

export default function NotFound() {

  const pathName = usePathname()
  const pathNames = pathName.split('/')
  let langCode = toLangCode(pathNames.length < 2 ? '' : pathNames[1])

  useEffect(() => {
    const redirectPath = getFullLocalizedUri('/not-found?from=' + pathName, langCode)
    redirect(redirectPath)
  }, [pathName])

  return (
    <html lang={langCode}>
      <body>
      </body>
    </html>
  )
}
